module.exports = __webpack_public_path__ + "img/a6.dd51ebce.jpg";